import { useCallback, useEffect, useState } from "react";
import axios from "axios";

// Shared across every screen that needs to know a tenant's sites (for a site picker, or to
// show a "which site" badge only once there's more than one) — one place to fetch the list
// instead of each component repeating its own axios.get(`${api}/sites`) + useState.
// `tenantId` is for a super admin's Providers screen: the sites come from the provider list (/auth/tenants, an
// account-level route), because /sites is provider data and stays closed to the platform until the provider
// switches support access on. Without it, the list is the signed-in provider's own sites.
export function useSites(api, tenantId) {
  const [sites, setSites] = useState([]);
  useEffect(() => {
    if (!api) return;
    const load = tenantId
      ? axios.get(`${api}/auth/tenants`).then((r) => r.data.find((t) => t.id === tenantId)?.sites || [])
      : axios.get(`${api}/sites`).then((r) => r.data);
    load.then(setSites).catch(() => {});
  }, [api, tenantId]);
  const siteName = useCallback((id) => sites.find((s) => s.id === id)?.name || "", [sites]);
  return { sites, siteName };
}
